// Vuex

import Request from './request';

// 获取地址
async function select(data) {
    return Request('get', 'api/hfdg-interface/get-hfdg-city/', data)
}

async function save(data) {
    return Request('post', 'api/hfdg-interface/add-company-user', data)
}

async function HFFileUpload(file, fileType) {
    var data = new FormData();
    data.append("file", file);
    data.append("file_type", fileType);
    return Request('post', "api/hfdg-interface/post-file", data);
}

async function bindCard(data) {
    return Request('post', 'api/hfdg-interface/bind-card', data)
}

async function getWithdraw(data) {
    return Request('get', 'api/hfdg-interface/withdraw', data)
}

async function getQueryUser(data) {
    return Request('get', 'api/hfdg-interface/query-user', data)
}

async function balancePay(data) {
    return Request('post', 'api/hfdg-interface/balance-pay', data)
}

async function enchashment(data) {
    return Request('post', 'api/hfdg-interface/enchashment', data)
}

async function balanceReturn(data) {
    return Request('post', 'api/hfdg-interface/balance-return', data)
}

export default {
    select,
    save,
    HFFileUpload,
    bindCard,
    getWithdraw,
    getQueryUser,
    balancePay,
    enchashment,
    balanceReturn,
}
